// extracted by mini-css-extract-plugin
export default {"menu":"HamburgerMenu_menu__+zcQ0","line":"HamburgerMenu_line__fRMPd","opened":"HamburgerMenu_opened__Ni87M"};